export class HtmlBuilder {
  constructor(ids, classes, content) {
    this.ids = ids
    this.classes = classes
    this.content = content
    console.log(this.classes)
  }

  build() {
    return `<wfs-tabs
      id="${this.ids.id}"
      classes="${this.classes.containerClasses}"
      content-id="${this.ids.contentId}"
      active-tab-classes="${this.classes.activeClasses}"
      inactive-tab-classes="${this.classes.inactiveClasses}"
    >
        <template v-slot:tabs>
            ${this.tabsHtml()}
        </template>
    </wfs-tabs>`
  }

  tabsHtml() {
    return this.content.sections.map(section => {
        return `<wfs-tab>
            <template v-slot:header>
                <div
                    id="header-${section.id}"
                    class="${this.classes.tabsClasses}"
                >${section.content.title}</div>
            </template>
            <template v-slot:content>${section.html}</template>
        </wfs-tab>`    
    }).join('')
  }
}